<template>
    <div class="fqa-container flex justify-center items-center w-100%">
        <AppHeader :title="t('fqa.title')" :show-back="true" />
        <div class="w-100% p-20px">
            <div class="flex mt-30px flex-col items-center justify-center">
                <p class="color-#FFFFFF text-center text-10px">
                    {{ t('fqa.description') }}
                </p>
            </div>
            <div class="overflow-y-auto fqa-list">
                <div v-for="(item, index) in list" class="mt-20px fqa-item">
                    <h2 class="color-#fff text-12px" :key="item.title">
                        {{ index + 1 }}. {{ item.title }}
                    </h2>
                    <p class="color-#fff lh-14px mt-5px opacity-60 text-10px" v-for="item in list" :key="item.title">
                        {{ item.content }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme';
import { AppHeader } from '@/components';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const list = [
    {
        title: t('fqa.howAlWork.title'),
        content: t('fqa.howAlWork.content'),
    },
    {
        title: t('fqa.howInteract.title'),
        content: t('fqa.howInteract.content'),
    },
    {
        title: t('fqa.privacy.title'),
        content: t('fqa.privacy.content'),
    },
    {
        title: t('fqa.customizeBehavior.title'),
        content: t('fqa.customizeBehavior.content'),
    },
];
</script>

<style scoped lang="scss">
.fqa-container {
    background: v-bind('theme.colors.background');
    padding-bottom: 50px;
}

.fqa-item {
    padding: 10px;
    background-color: v-bind('theme.colors.backgroundQuaternary');
    // border-bottom: 1px solid v-bind('theme.colors.border');
}
</style>
